import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActionPlanService } from '../../services/action-plan.service';

@Component({
  selector: 'app-action-plan-attachment',
  templateUrl: './action-plan-attachment.component.html',
  styleUrls: ['./action-plan-attachment.component.scss']
})
export class ActionPlanAttachmentComponent {
  @Input() openAttachmentModal:boolean=false;
  @Input() attachmentsData:any;
  @Output() attachmentsPopupVisible = new EventEmitter<boolean>();

  constructor(private actionPlanService: ActionPlanService){

  }

  ngOnInit(){
  }

  closeAttachmentsPopup(){
    this.attachmentsPopupVisible.emit(false);
  }

  downloadAttachment = (fileId: string, fileName: string) => {
    this.actionPlanService.downloadFile(fileId).subscribe((response) => {
      const fileUrl = response.fileUri;
      let downloadLink = document.createElement('a');
      document.body.appendChild(downloadLink);
      downloadLink.setAttribute('style', 'display: none');
      downloadLink.href = fileUrl;
      downloadLink.download = fileName;
      downloadLink.target = '_blank';
      downloadLink.click();
      downloadLink.remove();
    })
  }
}
